<link href="./dialog.component.scss" rel="stylesheet">

<div mat-dialog-title class="success-header">
  <i class="fa-solid fa-square-check success-icon"></i>
  Data Generated Successfully
</div>

<mat-dialog-content class="mat-typography dialog-content">
  <div class="icon-container">
    <i class="fa-regular fa-file-lines fa-2x success-badge"></i>
  </div>

  <div class="success-title">
    Download as Excel
  </div>

  <div class="success-description">Download a formatted Excel file with all classifications</div>

  <div class="btn generate-btn status-badge">
    <i class="fa fa-table table-icon" aria-hidden="true"></i> 2 Successful Tables Generated
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <div class="button-container">
    <button class="btn btn-primary generate-btn close-button">
      <i class="fa-solid fa-xmark"></i>&nbsp; Close
    </button>
    <button class="btn btn-primary generate-btn download-button">
      <i class="fa-solid fa-download"></i> &nbsp; Download
    </button>
    <button class="btn btn-primary generate-btn save-button">
      <i class="fa-solid fa-floppy-disk"></i>&nbsp; Save & Return to Home
    </button>
  </div>
</mat-dialog-actions>